import AdInterstitial from './AdInterstitial';

export default AdInterstitial;
